import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-linewords',
  templateUrl: './linewords.component.html',
  styleUrls: ['./linewords.component.css']
})
export class LinewordsComponent implements OnInit {

  @Input() lineWords_params: any = {}

  constructor() { }

  ngOnInit(): void {
  }

}
